import { useDispatch } from "react-redux";
import { Grid } from "@material-ui/core";
import FilePicker from "../file-picker/FilePicker";
import React from "react";
import { setSrc } from "../../store/slices/ModelSlice";

const ModelSelect = () => {
  const dispatch = useDispatch();
  const handleModelSrcChange = (value) => dispatch(setSrc(value));
  const types = ["gltf", "glb", "usdz"];
  return (
    <>
      <h6 className="p-3">Add Model</h6>
      <div className="inner-box">
        <Grid container className={"p-3"}>
          <Grid item xs={12}>
            <div className={"mb-3 px-2"}>Upload your model here:</div>
            <FilePicker
              types={types}
              formats={"glTF, GLB, USDZ"}
              updateFileUrl={handleModelSrcChange}
            />
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default ModelSelect;
